export const nigerianInstitutions = [
  "Abia State Polytechnic, Aba",
  "Abia State University, Uturu",
  "Abubakar Tafawa Balewa University, Bauchi",
  "Adamawa State College of Agriculture, Ganye",
  "Adamawa State Polytechnic, Yola",
  "Adamawa State University, Mubi",
  "Adekunle Ajasin University, Akungba-Akoko",
  "Adeyemi College of Education, Ondo",
  "Admiralty University of Nigeria, Ibusa",
  "Afe Babalola University, Ado-Ekiti",
  "Ahmadu Bello University, Zaria",
  "Air Force Institute of Technology, Kaduna",
  "Ajayi Crowther University, Oyo",
  "Akanu Ibiam Federal Polytechnic, Unwana",
  "Akperan Orshi College of Agriculture, Yandev",
  "Akwa Ibom State College of Agriculture, Obio Akpa",
  "Akwa Ibom State Polytechnic, Ikot Osurua",
  "Akwa Ibom State University, Ikot Akpaden",
  "Al-Hikmah University, Ilorin",
  "Al-Qalam University, Katsina",
  "Allover Central Polytechnic, Sango-Ota",
  "Ambrose Alli University, Ekpoma",
  "American University of Nigeria, Yola",
  "Anambra State College of Agriculture, Igbariam",
  "Anambra State Polytechnic, Mgbakwu",
  "Anambra State University, Uli",
  "Anchor University, Ayobo, Lagos",
  "Arthur Jarvis University, Akpabuyo",
  "Atiba University, Oyo",
  "Augustine University, Ilara-Epe",
  "Auchi Polytechnic, Auchi",
  "Babcock University, Ilishan-Remo",
  "Bauchi Institute for Arabic and Islamic Studies, Bauchi",
  "Bauchi State University, Gadau",
  "Bayero University, Kano",
  "Baze University, Abuja",
  "Bells University of Technology, Ota",
  "Benson Idahosa University, Benin City",
  "Benue State Polytechnic, Ugbokolo",
  "Benue State University, Makurdi",
  "Bingham University, Karu",
  "Binyaminu Usman Polytechnic, Hadejia",
  "Bowen University, Iwo",
  "Caleb University, Imota",
  "Caritas University, Amorji-Nike",
  "Cephas College of Education, Science and Technology, Lassa",
  "Chartered Institute of Personnel Management of Nigeria, Lagos",
  "Chrisland University, Owode",
  "Christopher University, Mowe",
  "City University of Science and Technology, Gusau",
  "Claretian University of Nigeria, Nekede",
  "College of Agriculture and Animal Science, Bakura",
  "College of Agriculture, Jalingo",
  "College of Education, Agbor",
  "College of Education, Akwanga",
  "College of Education, Azare",
  "College of Education, Ekiadolor",
  "College of Education, Gindiri",
  "College of Education, Ila-Orangun",
  "College of Education, Ikere-Ekiti",
  "College of Education, Jalingo",
  "College of Education, Katsina-Ala",
  "College of Education, Lagos",
  "College of Education, Maru",
  "College of Education, Minna",
  "College of Education, Oju",
  "College of Education, Oro",
  "College of Education, Port Harcourt",
  "College of Education, Warri",
  "College of Education, Zing",
  "Confluence University of Science and Technology, Osara",
  "Cooperative College, Kaduna",
  "Covenant University, Ota",
  "Crawford University, Igbesa",
  "Crescent University, Abeokuta",
  "Cross River State College of Agriculture, Obubra",
  "Cross River State University of Technology, Calabar",
  "Crown Hill University, Eiyenkorin",
  "David Umahi Federal University of Health Sciences, Uburu",
  "Delta State College of Agriculture, Anwai",
  "Delta State College of Education, Mosogar",
  "Delta State College of Education, Warri",
  "Delta State College of Physical Education, Mosogar",
  "Delta State Polytechnic, Ogwashi-Uku",
  "Delta State Polytechnic, Otefe-Oghara",
  "Delta State Polytechnic, Ozoro",
  "Delta State University, Abraka",
  "Dennis Osadebay University, Asaba",
  "Digital Bridge Institute, Lagos",
  "Dorben Polytechnic, Abuja",
  "Eastern Palm University, Ogboko",
  "Ebonyi State College of Education, Ikwo",
  "Ebonyi State University, Abakaliki",
  "Edo State Institute of Technology and Management, Usen",
  "Edo State Polytechnic, Usen",
  "Edo State University, Uzairue",
  "Edwin Clark University, Kiagbodo",
  "Ekiti State College of Agriculture and Technology, Isan-Ekiti",
  "Ekiti State University, Ado-Ekiti",
  "Elizade University, Ilara-Mokin",
  "Emmanuel Alayande College of Education, Oyo",
  "Enugu State College of Education, Enugu",
  "Enugu State University of Science and Technology, Enugu",
  "European University of Nigeria, Abuja",
  "Evangel University, Akaeze",
  "Federal College of Agriculture, Akure",
  "Federal College of Agriculture, Ibadan",
  "Federal College of Animal Health and Production Technology, Vom",
  "Federal College of Chemical and Leather Technology, Zaria",
  "Federal College of Dental Technology and Therapy, Enugu",
  "Federal College of Education, Abeokuta",
  "Federal College of Education, Asaba",
  "Federal College of Education, Bichi",
  "Federal College of Education, Eha-Amufu",
  "Federal College of Education, Gombe",
  "Federal College of Education, Kano",
  "Federal College of Education, Katsina",
  "Federal College of Education, Kontagora",
  "Federal College of Education, Obudu",
  "Federal College of Education, Okene",
  "Federal College of Education, Oyo",
  "Federal College of Education, Pankshin",
  "Federal College of Education, Potiskum",
  "Federal College of Education, Technical, Akoka",
  "Federal College of Education, Technical, Bichi",
  "Federal College of Education, Technical, Gombe",
  "Federal College of Education, Technical, Gusau",
  "Federal College of Education, Technical, Omoku",
  "Federal College of Education, Technical, Umunze",
  "Federal College of Education, Yola",
  "Federal College of Fisheries and Marine Technology, Lagos",
  "Federal College of Forestry, Ibadan",
  "Federal College of Forestry, Jos",
  "Federal College of Freshwater Fisheries Technology, New Bussa",
  "Federal College of Land Resources Technology, Kuru",
  "Federal College of Land Resources Technology, Owerri",
  "Federal College of Wildlife Management, New Bussa",
  "Federal College of Education, Zaria",
  "Federal Polytechnic, Ado-Ekiti",
  "Federal Polytechnic, Bida",
  "Federal Polytechnic, Damaturu",
  "Federal Polytechnic, Ede",
  "Federal Polytechnic, Ekowe",
  "Federal Polytechnic, Idah",
  "Federal Polytechnic, Ilaro",
  "Federal Polytechnic, Kaltungo",
  "Federal Polytechnic, Mubi",
  "Federal Polytechnic, Namoda",
  "Federal Polytechnic, Nasarawa",
  "Federal Polytechnic, Nekede",
  "Federal Polytechnic, Offa",
  "Federal Polytechnic, Oko",
  "Federal School of Dental Technology and Therapy, Enugu",
  "Federal School of Hygiene, Eleyele",
  "Federal School of Occupational Therapy, Lagos",
  "Federal School of Surveying, Oyo",
  "Federal University Birnin Kebbi, Birnin Kebbi",
  "Federal University Dutse, Dutse",
  "Federal University Dutsin-Ma, Dutsin-Ma",
  "Federal University Gashua, Gashua",
  "Federal University Gusau, Gusau",
  "Federal University Kashere, Kashere",
  "Federal University Lafia, Lafia",
  "Federal University Lokoja, Lokoja",
  "Federal University of Agriculture, Abeokuta",
  "Federal University of Agriculture, Makurdi",
  "Federal University of Health Sciences, Azare",
  "Federal University of Health Sciences, Ila-Orangun",
  "Federal University of Petroleum Resources, Effurun",
  "Federal University of Technology, Akure",
  "Federal University of Technology, Babura",
  "Federal University of Technology, Ikot Abasi",
  "Federal University of Technology, Minna",
  "Federal University of Technology, Owerri",
  "Federal University, Dutsin-Ma",
  "Federal University, Gashua",
  "Federal University, Gusau",
  "Federal University, Kashere",
  "Federal University, Lafia",
  "Federal University, Lokoja",
  "Federal University, Otuoke",
  "Federal University, Oye-Ekiti",
  "Federal University, Wukari",
  "Federal University of Health Sciences, Otukpo",
  "Fountain University, Osogbo",
  "Gateway Polytechnic, Saapade",
  "Gombe State College of Education, Billiri",
  "Gombe State Polytechnic, Bajoga",
  "Gombe State University, Gombe",
  "Grace Polytechnic, Surulere",
  "Gregory University, Uturu",
  "Hallmark University, Ijebu-Itele",
  "Hassan Usman Katsina Polytechnic, Katsina",
  "Havilla University, Nde-Ikom",
  "Heritage Polytechnic, Ikot Udota",
  "Hussaini Adamu Federal Polytechnic, Kazaure",
  "Ibrahim Badamasi Babangida University, Lapai",
  "Igbinedion University, Okada",
  "Imo State Polytechnic, Umuagwo",
  "Imo State School of Health Technology, Amaigbo",
  "Imo State University, Owerri",
  "Institute of Management and Technology, Enugu",
  "J. S. Tarka University, Makurdi",
  "Jama'atu College of Education, Gumel",
  "Jigawa State College of Education, Gumel",
  "Jigawa State College of Nursing and Midwifery, Dutse",
  "Jigawa State Polytechnic, Dutse",
  "Joseph Ayo Babalola University, Ikeji-Arakeji",
  "Kaduna Polytechnic, Kaduna",
  "Kaduna State College of Education, Gidan-Waya",
  "Kaduna State University, Kaduna",
  "Kano State College of Education, Kano",
  "Kano State Polytechnic, Kano",
  "Kano University of Science and Technology, Wudil",
  "Kebbi State College of Agriculture, Zuru",
  "Kebbi State Polytechnic, Dakingari",
  "Kebbi State University of Science and Technology, Aliero",
  "King David University of Medical Sciences, Uburu",
  "Kings University, Ode-Omu",
  "Kogi State College of Education, Ankpa",
  "Kogi State Polytechnic, Lokoja",
  "Kogi State University, Kabba",
  "Kola Daisi University, Ibadan",
  "Kwara State College of Arabic and Islamic Legal Studies, Ilorin",
  "Kwara State College of Education, Ilorin",
  "Kwara State College of Nursing and Midwifery, Ilorin",
  "Kwara State Polytechnic, Ilorin",
  "Kwara State University, Malete",
  "Ladoke Akintola University of Technology, Ogbomoso",
  "Lagos City Polytechnic, Ikeja",
  "Lagos State College of Health Technology, Yaba",
  "Lagos State Polytechnic, Ikorodu",
  "Lagos State University, Ojo",
  "Landmark University, Omu-Aran",
  "Lead City University, Ibadan",
  "Legacy University, Okija",
  "Madonna University, Elele",
  "Mai Idris Alooma Polytechnic, Geidam",
  "Maritime Academy of Nigeria, Oron",
  "Maryam Abacha American University of Nigeria, Kano",
  "McPherson University, Seriki Sotayo",
  "Michael and Cecilia Ibru University, Owhrode",
  "Michael Okpara University of Agriculture, Umudike",
  "Modibbo Adama University of Technology, Yola",
  "Mohammed Abdullahi Wase Polytechnic, Kano",
  "Moniya College of Education, Ibadan",
  "Mountain Top University, Makogi Oba",
  "Mudiame University, Irrua",
  "Muhyideen College of Education, Ilorin",
  "Nasarawa State College of Agriculture, Lafia",
  "Nasarawa State Polytechnic, Lafia",
  "Nasarawa State University, Keffi",
  "National Institute of Construction Technology, Uromi",
  "National Open University of Nigeria, Lagos",
  "Niger Delta University, Wilberforce Island",
  "Niger State College of Agriculture, Mokwa",
  "Niger State College of Nursing, Bida",
  "Niger State Polytechnic, Zungeru",
  "Nigeria Police Academy, Wudil",
  "Nigerian Army College of Nursing, Yaba",
  "Nigerian Army University, Biu",
  "Nigerian Defence Academy, Kaduna",
  "Nigerian Maritime University, Okerenkoko",
  "Nigerian Turkish Nile University, Abuja",
  "Nnamdi Azikiwe University, Awka",
  "Northwest University, Kano",
  "Novena University, Ogume",
  "Obafemi Awolowo University, Ile-Ife",
  "Obong University, Obong Ntak",
  "Oduduwa University, Ipetumodu",
  "Ogun State College of Health Technology, Ilese",
  "Ogun State Institute of Technology, Igbesa",
  "Oke-Ogun Polytechnic, Saki",
  "Olabisi Onabanjo University, Ago-Iwoye",
  "Ondo State University of Medical Sciences, Ondo",
  "Ondo State University of Science and Technology, Okitipupa",
  "Osun State College of Education, Ila-Orangun",
  "Osun State College of Technology, Esa-Oke",
  "Osun State Polytechnic, Iree",
  "Osun State University, Osogbo",
  "Our Saviour Institute of Science, Agriculture and Technology, Enugu",
  "Oyo State College of Agriculture and Technology, Igboora",
  "Oyo State College of Education, Oyo",
  "Pan-Atlantic University, Lagos",
  "Paul University, Awka",
  "Petroleum Training Institute, Effurun",
  "Plateau State College of Agriculture, Garkawa",
  "Plateau State Polytechnic, Barkin Ladi",
  "Plateau State University, Bokkos",
  "Precious Cornerstone University, Ibadan",
  "Prince Abubakar Audu University, Anyigba",
  "Provost College of Education, Warri",
  "Queen's College, Lagos",
  "Ramat Polytechnic, Maiduguri",
  "Redeemer's University, Ede",
  "Renaissance University, Enugu",
  "Rhema University, Aba",
  "Ritman University, Ikot Ekpene",
  "Rivers State College of Arts and Science, Port Harcourt",
  "Rivers State College of Health Science and Technology, Port Harcourt",
  "Rivers State Polytechnic, Bori",
  "Rivers State University, Port Harcourt",
  "Salem University, Lokoja",
  "Samaru College of Agriculture, Zaria",
  "Samuel Adegboyega University, Ogwa",
  "Saudi University of Nigeria, Kano",
  "Shaka Polytechnic, Benin City",
  "Shehu Idris College of Health Science and Technology, Makarfi",
  "Shehu Shagari College of Education, Sokoto",
  "Skyline University Nigeria, Kano",
  "Sokoto State Polytechnic, Sokoto",
  "Sokoto State University, Sokoto",
  "Southwestern University, Oku Owa",
  "Sports University, Idumuje-Ugboko",
  "Sule Lamido University, Kafin Hausa",
  "Summit University, Offa",
  "Tai Solarin College of Education, Omu-Ijebu",
  "Tai Solarin University of Education, Ijagun",
  "Tansian University, Umunya",
  "Taraba State College of Agriculture, Jalingo",
  "Taraba State Polytechnic, Suntai",
  "Taraba State University, Jalingo",
  "Technical College, Akure",
  "Technical College, Ibadan",
  "Technical College, Kaduna",
  "Technical College, Lagos",
  "Technical College, Port Harcourt",
  "The Nigerian College of Aviation Technology, Zaria",
  "The Polytechnic, Ibadan",
  "Thomas Adewumi University, Oko-Irese",
  "Topfaith University, Mkpatak",
  "Trinity University, Yaba",
  "Umar Ibn Ibrahim El-Kanemi College of Education, Science and Technology, Bama",
  "Umaru Musa Yar'adua University, Katsina",
  "University of Abuja, Abuja",
  "University of Africa, Toru-Orua",
  "University of Agriculture and Environmental Sciences, Umuagwo",
  "University of Benin, Benin City",
  "University of Calabar, Calabar",
  "University of Delta, Agbor",
  "University of Ibadan, Ibadan",
  "University of Ilesa, Ilesa",
  "University of Ilorin, Ilorin",
  "University of Jos, Jos",
  "University of Lagos, Lagos",
  "University of Maiduguri, Maiduguri",
  "University of Mkar, Mkar",
  "University of Nigeria, Nsukka",
  "University of Offa, Offa",
  "University of Owerri, Owerri",
  "University of Port Harcourt, Port Harcourt",
  "University of Uyo, Uyo",
  "Uranus University of Science and Technology, Ilorin",
  "Usmanu Danfodiyo University, Sokoto",
  "Veritas University, Abuja",
  "Waziri Umaru Federal Polytechnic, Birnin Kebbi",
  "Wellspring University, Benin City",
  "Wesley University of Science and Technology, Ondo",
  "Western Delta University, Oghara",
  "Yaba College of Technology, Yaba",
  "Yobe State College of Agriculture, Gujba",
  "Yobe State University, Damaturu",
  "Yusuf Maitama Sule University, Kano",
  "Zamfara State College of Agriculture and Animal Science, Bakura",
  "Zamfara State College of Education, Maru",
  "Zamfara State University, Talata Mafara"
];